export enum BomType {
  PRO = "PRO",
  PRO_X = "PRO_X",
  ENT = "ENT",
  ENT_X = "ENT_X",
  ENT_PLUS = "ENT_PLUS",
  ENT_PLUS_HYBRID = "ENT_PLUS_HYBRID",
  FREE = "FREE",
  PRO_TEAM = "PRO_TEAM",
  DEFAULT = "DEFAULT",
  JAS = "JAS",
}

export interface BomDto {
  type: BomType;
  trial: boolean;
}

export interface EntitlementDTO {
  name: string;
  value: string;
  excluded: boolean;
}
